
<template>
  <div id="user-manage">
    <!--搜索-->
    <div class="top">
      <el-col :span="12">
        <el-input placeholder="请输入内容" v-model="input" class="input-with-select" style="width: 100%">
          <el-button slot="append" icon="el-icon-search" @click="search">搜索</el-button>
        </el-input>
      </el-col>

    </div>
    <!--表格-->
    <div class="user-table">
      <el-table border :data="tableData">
        <el-table-column label="用户 ID" align="center" width="80" prop="id"></el-table-column>
        <el-table-column
        
          label="用户名"
          align="center"
          width="130"
          prop="name"
        ></el-table-column>
        
        <el-table-column label="头像" align="center" width="90">
          <template #default="{ row }">
            <img 
              :src="row.logo || 'https://www.windustry.cn/image/18516506793.jpg'"
              style="width: 40px; height: 40px; border-radius: 50%; object-fit: cover;"
            />
          </template>
        </el-table-column>
        <el-table-column label="过期时间" width="160" align="center" show-overflow-tooltip prop="vip_at"></el-table-column>
        
        <el-table-column label="手机号" align="center" width="120" prop="phone"></el-table-column>
        <el-table-column label="注册时间" align="center" show-overflow-tooltip prop="created"></el-table-column>
        <el-table-column label="是否VIP" align="center" show-overflow-tooltip prop="vip"></el-table-column>
        <el-table-column label="身份" align="center" width="100" prop="user_type"></el-table-column>
        <el-table-column align="center" width="200" label="操作">
          <template slot-scope="scope">
            <el-button
                size="mini"
                @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)">禁用</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <div class="block" v-if="tableData.length">
      <el-pagination
        @current-change="currentChange"
        background
        layout="prev, pager, next"
        :page-size="8"
        :page-count="total"
      ></el-pagination>
    </div>

    <!--修改管理员信息-->
    <div>
      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogFormVisible"
        :modal-append-to-body="false"
        v-if="dialogFormVisible"
        :showClose="false"
      >
        <el-form :label-position="labelPosition" :rules="rules" label-width="80px" :model="userInfo">
            
            <el-form-item label="过期时间" prop="vip_at" :readonly="true">
              <el-col :span="16">
                <el-input v-model="userInfo.vip_at"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item label="延长时间" prop="extend_days" >
              <el-col :span="16">
                <el-input 
                  v-model="extendDays"
                  placeholder="输入要延长的天数"
                  @input="handleExtendInput"
                  
                  type="tel"
                  min="0">
                  <template #append>天</template>
                </el-input>
              </el-col>
            </el-form-item>
            
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" @click="manageUserInfo()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  getCurrentPageAdmin,
  updateAdminInfo,
  getOptions3
} from "../../../api/index";
import { MessageBox, Message } from "element-ui";
export default {
  name: "AdminManage",
  data() {
    return {
      tableData: [],
      total: 0,
      extendDays:0,
      currentPage: 1,
      userInfo: {},
      dialogFormVisible: false,
      dialogTitle: "",
      originalVipAt:"",
      labelPosition: "right",
      input: "",
      searchInput: "",
      cinemaList: [],
      roleList: [],
      rules: {
        name: [
            { required: true, message: '用户名不能为空', trigger: 'change' },
        ],
        username: [
            { required: true, message: '账号不能为空', trigger: 'change' },
        ],
        password: [
            { required: true, message: '密码不能为空', trigger: 'change' },
        ],
        roleId: [
            { required: true, message: '角色不能为空', trigger: 'change' },
        ],
      },
    };
  },
  created() {
    this.loadCurrentPageUser(this.currentPage, 5, "");
  },
  methods: {
    async loadCurrentPageUser(currentPage, pageSize, input) {
      let json = await getCurrentPageAdmin(currentPage, pageSize, input);
      if (json.code === 200) {
        this.tableData = json.result;
        this.total = Math.ceil(json.total / 5);
        Message.success(json.msg)
      }
      else {
        Message.error(json.msg)
      }
    },
    async handleEdit(index, row) {
        this.loadOptions();
        this.dialogTitle = '编辑vip信息';
        this.userInfo = row;
        this.dialogFormVisible = true;
        this.originalVipAt = row.vip_at
        console.log(index, row);
    },
    async loadOptions(){
        let json = await getOptions3();
        if (json.state===200){
            this.roleList = json.data.roles;
          this.cinemaList = json.data.cinemas;
        }
    },
    async manageUserInfo(){
      let json = await updateAdminInfo(this.userInfo.id,this.userInfo.vip_at);
            if (json.code===200){
                this.dialogFormVisible = false;
                this.loadCurrentPageUser(this.currentPage,5,this.searchInput);
                Message.success(json.msg);
            } else{
                Message.error(json.msg);
                this.dialogFormVisible = false;
            }
    },
    async currentChange(currentPage) {
      this.currentPage = currentPage;
      this.loadCurrentPageUser(this.currentPage, 8, this.searchInput);
    },
    cancel() {
      this.loadCurrentPageUser(this.currentPage, 8, this.searchInput);
      this.dialogFormVisible = false;
    },
    addAdmin(){
        this.loadOptions();
        this.hallInfo = {};
        this.dialogFormVisible = true;
    },
    handleExtendInput(value) {
      // 只保留数字
      this.extendDays = value.replace(/[^\d]/g, '');
      
      // 计算新的过期时间
      this.calculateExpiration();
    },
    calculateExpiration() {
      const now = new Date();
      let baseDate = now;
      console.log('this.originalVipAt',this.originalVipAt)
      // 如果有原始过期时间且未过期，使用原始过期时间作为基准
      if (this.originalVipAt) {
        const [datePart, timePart] = this.originalVipAt.split(' ');
        const [year, month, day] = datePart.split('-');
        const [hours, minutes, seconds] = timePart.split(':');
        const vipDate = new Date(year, month - 1, day, hours, minutes, seconds);
        
        if (vipDate > now) {
          baseDate = vipDate;
        }
      }
      
      // 如果有输入天数，计算新时间
      if (this.extendDays) {
        const newDate = new Date(baseDate);
        newDate.setDate(newDate.getDate() + parseInt(this.extendDays));
        
        // 格式化显示
        const pad = num => num.toString().padStart(2, '0');
        this.displayVipAt = 
          `${newDate.getFullYear()}-${pad(newDate.getMonth() + 1)}-${pad(newDate.getDate())} ` +
          `${pad(newDate.getHours())}:${pad(newDate.getMinutes())}:${pad(newDate.getSeconds())}`;
          
        this.userInfo.vip_at = this.displayVipAt;
      } else {
        // 没有输入天数时，显示原始过期时间
        this.displayVipAt = this.originalVipAt;
        this.userInfo.vip_at = this.originalVipAt;
      }
    },
    //搜索用户
    search() {
      this.searchInput = this.input;
      this.loadCurrentPageUser(1, 8, this.searchInput);
    }
  },
  mounted() {
    // 初始化时保存原始过期时间
    this.originalVipAt = this.userInfo.vip_at;
    this.displayVipAt = this.userInfo.vip_at;
  }
};
</script>

<style scoped>
.user-table {
  width: 90%;
  min-width: 900px;
  margin: 0 auto;
  margin-bottom: 30px;
}
.top {
  display: flex;
  justify-content: center;
  align-items: center;
  /* padding: 30px 0; */
  margin-bottom: 30px;
}
.block {
  text-align: center;
}
.el-dialog__header {
  text-align: center;
}
.el-dialog__body .el-form-item {
  padding-left: 20%;
}
</style>


// WEBPACK FOOTER //
// src/pages/Home/children/AdminManage.vue